import getBlogMenuItem from './getBlogMenuItem';

const getPostFullUrl = (postUrl, menu) => {
  const blogMenuItem = getBlogMenuItem(menu);
  return blogMenuItem && typeof postUrl === 'string' ? `/${blogMenuItem.tag}${postUrl}` : '#';
};

export default getPostFullUrl;
